'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n'], ['\n  transition-property: ', ';\n  transition-duration: ', 'ms;\n  opacity: ', ';\n  transform: ', ';\n']);

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIPopoverHeader = require('./UIPopoverHeader');

var _UIPopoverHeader2 = _interopRequireDefault(_UIPopoverHeader);

var _UIPopoverBody = require('./UIPopoverBody');

var _UIPopoverBody2 = _interopRequireDefault(_UIPopoverBody);

var _UIPopoverFooter = require('./UIPopoverFooter');

var _UIPopoverFooter2 = _interopRequireDefault(_UIPopoverFooter);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _TwoWayTransition = require('../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _ClassNamePassthrough = require('../core/ClassNamePassthrough');

var _ClassNamePassthrough2 = _interopRequireDefault(_ClassNamePassthrough);

var _times = require('HubStyleTokens/times');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var POSITION_RELATIVE = {
  position: 'relative'
};

var USE_CLASSES = {
  default: 'uiPopover--default private-popover--default',
  longform: 'private-tooltip--longform',
  shepherd: 'private-popover--shepherd',
  tooltip: 'private-popover--tooltip',
  'tooltip-danger': 'private-popover--tooltip private-popover--tooltip-danger',
  unstyled: 'private-popover--unstyled'
};

var PopoverTransitionWrapper = (0, _styledComponents2.default)(_ClassNamePassthrough2.default).withConfig({
  displayName: 'UIPopoverContent__PopoverTransitionWrapper'
})(_templateObject, function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref2) {
  var duration = _ref2.duration;
  return duration;
}, function (_ref3) {
  var hidden = _ref3.hidden;
  return hidden ? '0.01' : '1';
}, function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden ? 'scale(.75)' : 'scale(1)';
});

var UIPopoverContent = _react2.default.createClass({
  displayName: 'UIPopoverContent',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool.isRequired,
    hasRendered: _react.PropTypes.bool.isRequired,
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf((0, _underscore.keys)(_UIPopoverArrow2.default.ARROW_SIZES)).isRequired,
    className: _react.PropTypes.string,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    id: _react.PropTypes.string,
    open: _react.PropTypes.bool,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    style: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
    width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      animateOnToggle: true,
      hasRendered: false,
      open: false,
      placement: 'top',
      use: 'default'
    };
  },
  getArrowParams: function getArrowParams() {
    return _UIPopoverArrow2.default.ARROW_SIZES[this.props.arrowSize];
  },
  getPopoverClassName: function getPopoverClassName(_ref5) {
    var className = _ref5.className,
        use = _ref5.use;

    return (0, _reactUtils.classNames)(className, USE_CLASSES[use], 'private-popover', 'uiPopover');
  },
  renderStructuredContent: function renderStructuredContent() {
    var content = this.props.content;
    var header = content.header,
        body = content.body,
        footer = content.footer;

    var headerArrow = this.renderHeaderArrow();
    var bodyArrow = this.renderBodyArrow();
    var footerArrow = this.renderFooterArrow();
    return [header ? _react2.default.createElement(
      _UIPopoverHeader2.default,
      { key: 'header' },
      header,
      headerArrow
    ) : headerArrow, body ? _react2.default.createElement(
      _UIPopoverBody2.default,
      { key: 'body' },
      body,
      bodyArrow
    ) : bodyArrow, footer ? _react2.default.createElement(
      _UIPopoverFooter2.default,
      { key: 'footer' },
      footer,
      footerArrow
    ) : footerArrow];
  },
  renderArrow: function renderArrow() {
    var _props = this.props,
        arrowColor = _props.arrowColor,
        arrowSize = _props.arrowSize,
        placement = _props.placement;

    var arrowParams = this.getArrowParams(arrowSize);
    return _react2.default.createElement(_UIPopoverArrow2.default, {
      color: arrowColor,
      inset: arrowParams.inset,
      key: 'arrow',
      placement: placement,
      width: arrowParams.width
    });
  },
  renderSimpleContent: function renderSimpleContent() {
    var content = this.props.content;

    return _react2.default.createElement(
      'div',
      { key: 'content' },
      content
    );
  },
  renderHeaderArrow: function renderHeaderArrow() {
    // Render the arrow in the header if we're on the bottom side or edge
    return this.props.placement.match(/bottom/) ? this.renderArrow() : null;
  },
  renderBodyArrow: function renderBodyArrow() {
    // Render the arrow in the body if we're not placed on the top or bottom
    return this.props.placement.match(/bottom|top/) ? null : this.renderArrow();
  },
  renderFooterArrow: function renderFooterArrow() {
    // Render the arrow in the footer if we're on the top side or edge
    return this.props.placement.match(/top/) ? this.renderArrow() : null;
  },
  renderPopoverContent: function renderPopoverContent(_ref6) {
    var className = _ref6.className,
        content = _ref6.content,
        id = _ref6.id,
        open = _ref6.open,
        width = _ref6.width,
        style = _ref6.style,
        use = _ref6.use,
        rest = _objectWithoutProperties(_ref6, ['className', 'content', 'id', 'open', 'width', 'style', 'use']);

    var widthStyle = width ? { maxWidth: width, width: width } : {};

    if (open) {
      return _react2.default.createElement(
        'div',
        _extends({
          className: this.getPopoverClassName({ className: className, use: use }),
          id: id,
          style: _extends({}, POSITION_RELATIVE, widthStyle, style)
        }, rest),
        _react2.default.isValidElement(content) ? [this.renderArrow(), this.renderSimpleContent()] : this.renderStructuredContent()
      );
    }

    return null;
  },
  render: function render() {
    var _props2 = this.props,
        animateOnMount = _props2.animateOnMount,
        animateOnToggle = _props2.animateOnToggle,
        __arrowColor = _props2.arrowColor,
        __arrowSize = _props2.arrowSize,
        className = _props2.className,
        content = _props2.content,
        hasRendered = _props2.hasRendered,
        id = _props2.id,
        open = _props2.open,
        __placement = _props2.placement,
        style = _props2.style,
        use = _props2.use,
        width = _props2.width,
        rest = _objectWithoutProperties(_props2, ['animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'className', 'content', 'hasRendered', 'id', 'open', 'placement', 'style', 'use', 'width']);

    return _react2.default.createElement(
      _TwoWayTransition2.default,
      {
        transitionOnMount: animateOnMount && !hasRendered || animateOnToggle && hasRendered,
        transitionOnUpdate: animateOnToggle,
        duration: parseInt(_times.POPOVER_TRANSITION_TIMING, 10),
        Wrapper: PopoverTransitionWrapper
      },
      this.renderPopoverContent(_extends({
        className: className,
        content: content,
        id: id,
        open: open,
        width: width,
        style: style,
        use: use
      }, rest))
    );
  }
});

exports.default = UIPopoverContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/tooltip/UIPopoverContent.js
// module id = 254
// module chunks = 0